export const MODAL_CLOSE_BTN_ID = 'ModalCloseBtnId';
